const TYPE_ENUM = {
  SINGLE: 'single',
  MULTI: 'multi'
}

const isSingle = value => value.toLowerCase() === TYPE_ENUM.SINGLE

const isMulti = value => value.toLowerCase() === TYPE_ENUM.MULTI

export { isSingle, isMulti, TYPE_ENUM }
